var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71792 10.2596C8.32506 10.6648 7.67494 10.6648 7.28208 10.2596L0.67523 3.44588C0.299029 3.0579 0.299137 2.44123 0.675475 2.05338L1.94987 0.740015C2.34283 0.335037 2.99284 0.335209 3.38559 0.740395L7.28196 4.76018C7.67485 5.16552 8.32515 5.16552 8.71804 4.76018L12.6144 0.740395C13.0072 0.335208 13.6572 0.335037 14.0501 0.740015L15.3245 2.05338C15.7009 2.44123 15.701 3.0579 15.3248 3.44588L8.71792 10.2596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpIcon);
export default __webpack_public_path__ + "static/media/chevronUpIcon.49c7367707ae445da94ec0ee9fc15b51.svg";
export { ForwardRef as ReactComponent };